import { Node } from '.';

export class UserSelection {
    public selectedNode: Node;
    public value: string;
    public formInvalid: boolean;
}
